const convertCouponCode = async (couponCodes: string[]): Promise<string> => {
  const NUMBERS = '0123456789'.split('')
  const CHARS = 'ABCEFGHJKMNPQRSTWXY'.split('') // NG: DIOZ
  let nextCode = [...Array(12)]
    .map((_) => {
      return Math.random() > 0.5
        ? NUMBERS[Math.floor(Math.random() * NUMBERS.length)]
        : CHARS[Math.floor(Math.random() * CHARS.length)]
    })
    .join('')
  // クーポンコードの重複を防ぐために再帰処理
  nextCode = couponCodes.includes(nextCode) ? await convertCouponCode(couponCodes) : nextCode
  return nextCode
}

export default convertCouponCode
